import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { auth } from "../firebase";
import { useAuth } from "../contexts/AuthContext";

function Logout() {
  const navigate = useNavigate();
  const { userInfo } = useAuth();

  useEffect(() => {
    signOut(auth).then(() => {
      sessionStorage.removeItem("userInfo");
      navigate("/Login", { replace: true });
    });
  }, [navigate, userInfo?.site_name]);

  return (
    <div>
      <h1>Signing out…</h1>
    </div>
  );
}

export default Logout;
